import { COUNTRY_SHORTS } from '~/constants/'

export default function useGeolocation() {
  const geolocation = useGeolocationData()

  if (isMetaServer) {
    const event = useRequestEvent()
    geolocation.value = event?.context.geolocation
  }

  const isInCa = computed(() => geolocation.value?.countryCode === COUNTRY_SHORTS.CA)
  const isInUs = computed(() => geolocation.value?.countryCode === COUNTRY_SHORTS.US)
  const isInCaOrUs = computed(() => isInCa.value || isInUs.value)

  return {
    geolocation,
    isInCa,
    isInUs,
    isInCaOrUs,
  }
}
